import React from 'react';
import { Box, Typography, Paper } from '@mui/material';
import PropTypes from 'prop-types';

const PageLayout = ({
  title,
  children,
  contentSx,
  topBar,
  titleBarContent,
  allowTitleBarWrap = false,
  ...props
}) => {
  return (
    <Box sx={{ flex: 1, minWidth: 0, minHeight: 0, overflowY: 'auto', overflowX: 'auto' }} {...props}>
      {title && (
        <Paper
          elevation={0}
          className="fade-in"
          sx={{
            ...(allowTitleBarWrap
              ? {
                  minHeight: '57px',
                  paddingY: 1,
                }
              : {
                  height: '57px',
                  minHeight: '57px',
                }),
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            px: 2,
            borderBottom: 1,
            borderColor: 'divider',
            bgcolor: 'background.paper',
            borderRadius: 0,
            position: 'sticky',
            top: 0,
            zIndex: 1000,
          }}
        >
          <Box
            className="staggered-animation"
            sx={{ display: 'flex', alignItems: 'center', width: '100%' }}
          >
            <Typography
              variant="h6"
              component="h1"
              sx={{ fontSize: '1.1rem', fontWeight: 500, flexShrink: 0 }}
            >
              {title}
            </Typography>
            {titleBarContent && (
              <Box
                sx={{
                  display: 'flex',
                  alignItems: allowTitleBarWrap ? 'flex-start' : 'center',
                  gap: 2,
                  flex: 1,
                  pl: 2,
                  ...(allowTitleBarWrap && {
                    flexWrap: 'wrap',
                    minHeight: '41px', // Account for title height
                  }),
                }}
              >
                {titleBarContent}
              </Box>
            )}
          </Box>
        </Paper>
      )}
      {topBar && topBar}
      <Box
        sx={{
          px: 3,
          pb: 3,
          pt: 3,
          minWidth: 0,
          overflowX: 'auto',
          ...contentSx,
        }}
      >
        {children}
      </Box>
    </Box>
  );
};

PageLayout.propTypes = {
  title: PropTypes.node,
  children: PropTypes.node.isRequired,
  contentSx: PropTypes.object,
  topBar: PropTypes.node,
  titleBarContent: PropTypes.node,
  allowTitleBarWrap: PropTypes.bool,
};

export default PageLayout;
